<script setup lang="ts"></script>

<template>
  <div class="profile-channel__list-item">
    <div class="profile-channel__list-item-info">
      <div class="profile-channel__list-item-name color-[#91A0AE]">Канал</div>
      <div class="profile-channel__list-item-limit color-[#91A0AE]">
        <div>Остаток диалогов</div>
        <PTooltip placement="top" class="profile-channel__list-item-name-icon">
          <template #activator>
            <IconInfoSm class="color-[#91A0AE]" />
          </template>

          <template #text>
            <span style="color: var(--common-black)">Текущий остаток и лимит уникальных диалогов. Показывает, скольким
              пользователям можно отправить шаблонные сообщения сегодня.
            </span>
          </template>
        </PTooltip>
      </div>
      <div class="profile-channel__list-item-status color-[#91A0AE]">Статус</div>
    </div>
  </div>
  <div class="profile-channel__list-divider"></div>
</template>

<style lang="scss" scoped>
.profile-channel__list-item {
  box-sizing: border-box;
  padding: 12px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;

  &-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
  }

  &-name {
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    width: 300px;
    gap: 8px;
    display: flex;

    &-icon {
      gap: 4px;
    }
  }

  &-limit {
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    width: 224px;
    gap: 8px;
    display: flex;
  }

  &-status {
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    width: 180px;
    gap: 8px;
  }
}

.profile-channel__list-divider {
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  width: 100%;
  margin: 8px 0;
}
</style>
